import React from "react";
import { Redirect, Route, Switch, useLocation, useRouteMatch } from "react-router-dom";

import PermissionedRoute from "./PermissionedRoute";
import Permissions from "../permissions";

import Reservations from "../views/Rider/Reservations";
import Transactions from "../views/Rider/Transactions";
import ReservationDetail from "../views/Rider/ReservationDetail";
import GroupReservations from "../views/Rider/GroupReservations";
import GroupReservationDetail from "../views/Rider/GroupReservationDetail";

export const RiderProfileRouter = () => {
  const location = useLocation();
  const { path } = useRouteMatch();

  return (
    <Switch>
      <PermissionedRoute
        permission={Permissions.readRidersAdmin}
        exact
        path={`${path}/reservations`}
      >
        <Reservations />
      </PermissionedRoute>
      <PermissionedRoute
        permission={Permissions.readRidersAdmin}
        exact
        path={`${path}/group-reservations`}
      >
        <GroupReservations />
      </PermissionedRoute>
      <PermissionedRoute
        permission={Permissions.readWallet}
        exact
        path={`${path}/wallet/transactions`}
      >
        <Transactions />
      </PermissionedRoute>
      <PermissionedRoute
        permission={Permissions.readRidersAdmin}
        exact
        path={`${path}/reservations/:reservationId`}
      >
        <ReservationDetail />
      </PermissionedRoute>
      <PermissionedRoute
        permission={Permissions.readRidersAdmin}
        exact
        path={`${path}/group-reservations/:groupReservationId`}
      >
        <GroupReservationDetail />
      </PermissionedRoute>
      <Route exact path={`${path}`}>
        <Redirect to={`${location.pathname}/reservations`} />
      </Route>
    </Switch>
  );
};

export default RiderProfileRouter;
